import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/asset_collection/assets/$assetId/')({
    beforeLoad: () => {
        throw redirect({
            to: '/asset_collection',
        });
    },
});
